import { useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { ColorPicker, HtmlText, ContentEditorDialog } from '../../../../../Global/Components';
import { isHtml } from '../../../../../Global/Functions';
import MenuList from '../MenuList';
import { v4 } from 'uuid';

export default function TextBox({ open, onEdit, initial, editable, onDelete, onChange }) {
  const [text, setText] = useState(initial?.text || '');
  const [dialog, setDialog] = useState(false);
  const [colorPicker, setColorPicker] = useState(null);
  const [color, setColor] = useState(undefined);
  const [elementId] = useState(v4());

  useEffect(() => {
    if (!open) return;
    setText(initial?.text || '');
  }, [initial, open]);

  useEffect(() => {
    if (initial?.color) {
      setColor(initial.color);
    }
  }, [initial]);

  function saveColor(col) {
    setColor(col);
    onChange({ color: col });
  }

  return (
    <Grid
      container
      direction={'column'}
      style={{ height: '100%', position: 'relative', backgroundColor: color || 'inherit' }}
      id={elementId}
    >
      <Grid
        container
        item
        sx={{ height: '100%', overflow: 'hidden', position: 'relative', flex: 1 }}
        alignItems="flex-start"
      >
        {editable && (
          <>
            <ColorPicker
              anchor={colorPicker}
              open={Boolean(colorPicker)}
              column={400}
              customPicker
              onClose={(res) => {
                if (res?.color) {
                  saveColor(res?.color);
                }
                setColorPicker(null);
              }}
              className="non-draggable"
            />
            <Grid
              container
              item
              justifyContent={'flex-end'}
              sx={{ position: 'absolute', zIndex: 1, top: 15, left: -10 }}
            >
              <MenuList
                mode={'textbox'}
                onDelete={onDelete}
                setColorPicker={setColorPicker}
                color={color}
                onChange={onChange}
              />
            </Grid>
          </>
        )}
        <Grid
          container
          alignItems="flex-start"
          sx={{
            height: '100%',
            position: 'absolute',
            left: 0,
            top: 0,
            px: 2,
            cursor: editable ? 'grab' : '',
          }}
        >
          <Grid
            container
            alignItems="flex-start"
            style={{
              height: '100%',
              maxHeight: '100%',
              cursor: editable ? 'pointer' : '',
              overflow: 'auto',
            }}
            onClick={editable ? () => setDialog(true) : undefined}
          >
            {isHtml(text) ? (
              <HtmlText value={text} />
            ) : editable && !text ? (
              <Typography color="textSecondary">Click to add text</Typography>
            ) : (
              <Typography
                style={{
                  maxHeight: '100%',
                  overflow: 'auto',
                  whiteSpace: 'break-spaces',
                }}
              >
                {text}
              </Typography>
            )}
          </Grid>
        </Grid>
        {editable && (
          <ContentEditorDialog
            open={dialog}
            onClose={() => setDialog(false)}
            initial={text}
            onResult={(txt) => {
              setText(txt);
              onEdit({ text: txt });
            }}
          />
        )}
      </Grid>
    </Grid>
  );
}
